module.exports = ".error-msg {\n  color: #cd3a58;\n  position: absolute;\n  top: 38px;\n  left: 12px;\n  font-size: 13px; }\n\n.error-icon {\n  top: 0px;\n  color: #19cac1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/alert-message/alert.component.scss
// module id = ./src/app/shared/alert-message/alert.component.scss
// module chunks = main